<template>
  <div v-if="report.length === 0 && loading === false">
    No data available
  </div>
  <graph-skeleton class="mx-3" v-else-if="report.length === 0"></graph-skeleton>
  <div v-else id="reportChart">
    <div :class="(index === Object.keys(graphs).length - 1 && Object.keys(graphs).length % 2) ? 'col-xl-12' : 'col-xl-6'" class="chartCol" v-for="(graph, name, index) in graphs" :key="name">
      <highcharts :options="graph" ref="highcharts"></highcharts>
    </div>
  </div>
</template>

<style scoped>
.chartCol {
  display: inline-block;
}
#reportChart {
  overflow: hidden;
}
</style>

<script>
  import { getPrettyStatName, getEntryName, graphColors, formatStat } from '@/reports/components/ReportUtils'
  import { getTooltipHTML } from '@/reports/components/graphs/ReportGraphUtils'
  import GraphSkeleton from '@/reports/components/graphs/GraphSkeleton'
  export default {
    props: {
      report: { required: true, type: Array },
      stats: { required: true, type: Array },
      fields: { required: true, type: Array },
      timezone: { required: false, type: String },
      currentlyViewedReport: { required: true, type: Array },
      loading: { type: Boolean, default: true }
    },
    data() {
      return {
        nameToColor: {},
        oldViewedReport: []
      }
    },
    watch: {
      currentlyViewedReport: {
        handler: function() {
          this.$nextTick(function() {
            for(let row of this.currentlyViewedReport) {
              let name = getEntryName(row, this.fields)
              if(row.disabled) {
                this.hideSeries(name)
              } else {
                this.showSeries(name)
              }
            }
          })
        },
        deep: true
      }
    },
    methods: {
      shuffleColors () {
        return graphColors.slice(0, this.currentlyViewedReport.length).sort(function() {
          return 0.5 - Math.random()
        })
      },
      getNewColorSeries () {
        let colorOn = 0
        let shuffledColors = this.shuffleColors()
        this.nameToColor = {}
        for(let row of this.currentlyViewedReport) {
          let name = getEntryName(row, this.fields)
          if(!(name in this.nameToColor)) {
            this.nameToColor[name] = shuffledColors[colorOn++]
          }
        }
        this.$emit('color-update', this.nameToColor)
      },
      getMultipleSeries() {
        if(this.majorGraphChange) {
          this.getNewColorSeries()
        }
        this.oldViewedReport = this.currentlyViewedReport
        let graphs = {}
        //get the field that isn't date
        for(let stat of this.stats) {
          graphs[stat] = []
          for(let row of this.currentlyViewedReport) {
            let name = getEntryName(row, this.fields)
            graphs[stat].push( { name: name, value: Number(row[stat])} )
          }
        }
        //now we have all the data, it's just not formatted right
        for(let stat in graphs) {
          let arr = []
          for(let entry of graphs[stat]) {
            arr.push( { name: entry.name, data: [entry.value], color: this.nameToColor[entry.name] } )
          }
          graphs[stat] = arr
        }
        return graphs
      },
      //get all charts that are truthy
      getValidCharts() {
        let list = this.Highcharts.charts.filter( chart => chart )
        return list
      },
      hideSeries(name) {
        for (let chart of this.getValidCharts()) {
          let seriesList = chart.series.filter( series => series.name === name )
          for(let series of seriesList) {
            if(series.visible){
              series.hide()
            }
          }
        }
      },
      showSeries(name) {
        for (let chart of this.getValidCharts()) {
          let seriesList = chart.series.filter( series => series.name === name )
          for(let series of seriesList) {
            if(!series.visible){
              series.show()
            }
          }
        }
      },
    },
    computed: {
      /*
       * determines whether currentlyViewedReport is a major change
       * (ie, different field names) from oldViewedReport
       * used to determine whether we need to recompute colors or not
       */
      majorGraphChange () {
        for(let field of this.fields) {
          for(let row of this.currentlyViewedReport) {
            if(row[field] && !this.oldViewedReport.find(oldRow => row[field] === oldRow[field] )) {
              return true
            }
          }
        }
        return false
      },
      computedSeries () {
        return this.getMultipleSeries()
      },
      graphs() {
        let vm = this
        let graphs = {}
        for(let graph in this.computedSeries) {
          graphs[graph] = {
            chart: {
              type: 'column',
              height: 300,
              style: {
                fontFamily: 'Gilroy, Helvetica, sans-serif'
              }
            },
            //colors: this.shuffledColors,
            title: {
              text: '',
            },
            xAxis: {
              categories: [getPrettyStatName(graph)]
            },
            plotOptions: {
              series: {
                groupPadding: 0,
                events: {
                  hide: function(e) {
                    vm.hideSeries(e.target.name)
                  },
                  show: function(e) {
                    vm.showSeries(e.target.name)
                  }
                }
              }
            },
            yAxis: {
              title: ''
            },
            legend: {
              enabled: false
            },
            series: this.computedSeries[graph],
            credits: {
              enabled: false
            },
            tooltip: {
              useHTML: true,
              borderColor: '#1C1D29',
              backgroundColor: '#1C1D29',
              borderRadius: 5,
              followPointer: false,
              shared: this.jointTooltip,
              formatter: function () {
                return getTooltipHTML(getPrettyStatName(graph), [{ name: this.point.series.name, color: this.point.color, value: formatStat(graph, this.point.y)}])
              }
            }
          }
        }
        return graphs
      }
    },
    components: {
      GraphSkeleton
    }
  }
</script>



// WEBPACK FOOTER //
// src/reports/components/graphs/ReportBarGraphs.vue